var moduleMap = {
	"./store": () => {
		return Promise.all(/* __federation_expose_store */[__webpack_require__.e(30131), __webpack_require__.e(80514), __webpack_require__.e(60547)]).then(() => (() => ((__webpack_require__(26944)))));
	},
	"./store/invoice/actions": () => {
		return Promise.all(/* __federation_expose_store__invoice__actions */[__webpack_require__.e(30131), __webpack_require__.e(50221)]).then(() => (() => ((__webpack_require__(43541)))));
	},
	"./store/customInvoice/actions": () => {
		return Promise.all(/* __federation_expose_store__customInvoice__actions */[__webpack_require__.e(30131), __webpack_require__.e(34155), __webpack_require__.e(32268)]).then(() => (() => ((__webpack_require__(82157)))));
	},
	"./store/engagement/actions": () => {
		return __webpack_require__.e(/* __federation_expose_store__engagement__actions */ 71895).then(() => (() => ((__webpack_require__(49698)))));
	},
	"./store/onDemand/actions": () => {
		return Promise.all(/* __federation_expose_store__onDemand__actions */[__webpack_require__.e(30131), __webpack_require__.e(34270)]).then(() => (() => ((__webpack_require__(70309)))));
	},
	"./store/recurring/actions": () => {
		return Promise.all(/* __federation_expose_store__recurring__actions */[__webpack_require__.e(30131), __webpack_require__.e(32093)]).then(() => (() => ((__webpack_require__(2357)))));
	},
	"./mfe-config": () => {
		return __webpack_require__.e(/* __federation_expose_mfe_config */ 63679).then(() => (() => ((__webpack_require__(79717)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});